import { OrbitalTrackRentalPopupType } from '@apeiron/orbital'
import { ApeironCheckbox } from '@apeiron/ui'
import { styled } from '@mui/material'
import { useOrbitalTrackRenewDetachContext } from '@src/contexts/orbitalTrack/OrbtialTrackRenewDetachContext'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Checkbox = styled(ApeironCheckbox)`
  padding: 20px;
  justify-content: flex-start;
  .Custom-Description {
    max-width: unset;
    ${props => props.theme.breakpoints.down('res1280')} {
      font-size: 12px;
      line-height: 18px;
      max-width: 600px;
    }
  }
`

const RentalTermsSection: FC<Props> = props => {
  const { popupType } = props

  const { checked, done, setChecked } = useOrbitalTrackRenewDetachContext()

  const { t } = useTranslation()

  const handleOnChange = useCallback(() => {
    setChecked(!checked)
  }, [checked])

  return (
    <Checkbox
      checked={checked}
      description={
        popupType === OrbitalTrackRentalPopupType.Renew
          ? t('godiverse.orbital_track.attach_planet.checkbox')
          : t('godiverse.orbital_track.rental_popup.checkbox')
      }
      disabled={done}
      onChange={handleOnChange}
    />
  )
}

type Props = {
  popupType: OrbitalTrackRentalPopupType
}

export default RentalTermsSection
